import { render } from "./Star3Demo.vue?vue&type=template&id=02546d6e&scoped=true&ts=true"
import script from "./Star3Demo.vue?vue&type=script&lang=ts"
export * from "./Star3Demo.vue?vue&type=script&lang=ts"

import "./Star3Demo.vue?vue&type=style&index=0&id=02546d6e&lang=less"
import "./Star3Demo.vue?vue&type=style&index=1&id=02546d6e&scoped=true&lang=less"

import exportComponent from "/home/www-fe/fe-prod/workspace/talbook_bfe_h5_base_frame_refs-heads-master/source_code/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02546d6e"]])

export default __exports__